import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaddingHorizontal20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPaddingHorizontal20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.25 17.002a.75.75 0 0 1-.75-.75V3.75a.75.75 0 0 1 1.5 0v12.502a.75.75 0 0 1-.75.75M11.5 7.5h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1M10 6h1.5A2.5 2.5 0 0 1 14 8.5v3a2.5 2.5 0 0 1-2.5 2.5h-3A2.5 2.5 0 0 1 6 11.5v-3A2.5 2.5 0 0 1 8.5 6zM2.002 16.252a.75.75 0 0 0 1.5 0V3.75a.75.75 0 1 0-1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaddingHorizontal20);
